import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=bded3f84&scoped=true&"
import script from "./customList.vue?vue&type=script&lang=js&"
export * from "./customList.vue?vue&type=script&lang=js&"
import style0 from "./customList.vue?vue&type=style&index=0&id=bded3f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bded3f84",
  null
  
)

export default component.exports